// extracted by mini-css-extract-plugin
module.exports = {"footer":"style__footer__2SNqh","wrapper":"style__wrapper__K1GSD"};